// extracted by mini-css-extract-plugin
export default {"parent":"media_parent__n0yA8","parentTitle":"media_parentTitle__BKC1l","parentDescription":"media_parentDescription__tGUB1"};